import { _CO, _MONTHS } from "../../../utils/constants";
import { createColumn } from "../../../utils/AgGridUtils/ColumnBuilders/createColumn";

const ColumnBuilder = () => {
  const generatedColumns = [];

  generatedColumns.push(
    createColumn({
      headerName: "Sources",
      field: "sourceName",
      tooltipValueGetter: (params) => params.value,
      cellStyle: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
      minWidth: 200,
    }),
  );

  for (let i = 1; i <= 12; i++) {
    const fiscalMonthIndex = _CO[i];
    generatedColumns.push(
      createColumn({
        headerName: _MONTHS[fiscalMonthIndex],
        field: `months.${fiscalMonthIndex}`,
        editable: true,
        aggFunc: "sum",
        headerClass: "month-header",
        textAlign: 'center',
        valueFormatter: (params) => `${params.value ? params.value : 0} %`,
        valueParser: (params) => parseFloat(params.newValue),
        cellStyle: (params) => {
          const color = params.value > 100 ? "red" : "black";
          return { color: color,textAlign: 'center' };
        },
      }),
    );
  }

  return generatedColumns;
};

export default ColumnBuilder;
